/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    poRequests: {},
    poRequest: {},
    isLoadingTable: false,
    showDeleteModal: false,
    showHistoryLog: false,
    historyLog: ""
}

const mutations = {
    getPaginatedPoRequests(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/porequests/page=${payload.page}&pageSize=${payload.pageSize}/byStatus=${payload.status}/${payload.query}`).then(response => {
            response.data.data.forEach(po => {
                po.dateCreated = moment(po.dateCreated).format('MM/DD/YYYY HH:mm')
                po.totalCost = numeral(po.totalCost).format('0,0.00')
                po.selling = numeral(po.selling).format('0,0.00')
                po.profit = numeral(po.profit).format('0,0.00')
            })
            state.poRequests = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    getPaginatedPoRequestsForFinalApproval(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/porequests/for-final-approvals/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(po => {
                po.dateCreated = moment(po.dateCreated).format('MM/DD/YYYY HH:mm')
                po.totalCost = numeral(po.totalCost).format('0,0.00')
                po.selling = numeral(po.selling).format('0,0.00')
                po.profit = numeral(po.profit).format('0,0.00')
            })
            state.poRequests = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.poRequest) {
            state.poRequest = payload.poRequest
        } else {
            state.poRequest = {}
        }
    },
    openHistoryLogModal(state, payload) {
        state.showHistoryLog = payload.showHistoryLog
        if (payload.showHistoryLog) {
            state.historyLog = payload.historyLog
        } else {
            state.historyLog = ""
        }
    }
}

const actions = {
    getPaginatedPoRequests({
        commit
    }, payload) {
        commit('getPaginatedPoRequests', payload)
    },
    getPaginatedPoRequestsForFinalApproval({
        commit
    }, payload) {
        commit('getPaginatedPoRequestsForFinalApproval', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    },
    openHistoryLogModal({
        commit
    }, payload) {
        commit('openHistoryLogModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}